goog.provide("shadow.js.shim.module$moment$min$moment_with_locales$default");
shadow.js.shim.module$moment$min$moment_with_locales$default = shadow.js.shim.module$moment$min$moment_with_locales.default;
